import { SumArrayElements } from "../../../../shared/scripts/array-functions";
import { ChartDataPoint } from "./enrollment.chart-controller";
import { AggregatedParticipants, Participant } from "./enrollment.entities";
import { IEnrollmentPageData } from "./enrollment.page";



var Highcharts = require('highcharts/highcharts');
//require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/solid-gauge')(Highcharts);

export class EnrollmentGauges {

    parent: IEnrollmentPageData;

    exIntGauge: any;
    exIntChart: any;
    cogDysGauge: any;
    cogDysChart: any;
    autoGauge: any;
    autoChart: any;
    sleep1Gauge: any; //s
    sleep1Chart: any; //s
    sleep2Gauge: any; //s
    sleep2Chart: any; //s
    auto1Gauge: any;
    auto1Chart: any;
    auto2Gauge: any;
    auto2Chart: any;
    energize1Gauge: any; 
    energize1Chart: any;
    energize2Gauge: any;
    energize2Chart: any;

    sleep1Target: number;
    sleep2Target: number;
    auto1target: number;
    auto2target: number;
    energize1target: number;
    energize2target: number;
    constructor(parent: IEnrollmentPageData) {
        this.parent = parent;

        let cardOptions: any[] = [{ buttonId: '#toggle-sxcluster-exint', cardId: '#card-sxcluster-exint' },
                                    { buttonId: '#toggle-sxcluster-cogdys', cardId: '#card-sxcluster-cogdys' },
                                    { buttonId: '#toggle-sxcluster-auto', cardId: '#card-sxcluster-auto' },
                                    { buttonId: '#toggle-sxcluster-sleep1', cardId: '#card-sxcluster-sleep1' },   //s
                                    { buttonId: '#toggle-sxcluster-sleep2', cardId: '#card-sxcluster-sleep2' },
                                    { buttonId: '#toggle-sxcluster-auto1', cardId: '#card-sxcluster-auto1' },
                                    { buttonId: '#toggle-sxcluster-auto2', cardId: '#card-sxcluster-auto2' },
                                    { buttonId: '#toggle-sxcluster-energize1', cardId: '#card-sxcluster-energize1' },
                                    { buttonId: '#toggle-sxcluster-energize2', cardId: '#card-sxcluster-energize2' }];    //s

        cardOptions.forEach((option: any) => {
            $(option.buttonId).on('click', (e) => {
                e.preventDefault();
                $(option.cardId).toggleClass('flipped');
                if ($(option.cardId).hasClass('flipped')) {
                    $(option.buttonId + " .line-chart-icon").removeClass('fa-chart-line');
                    $(option.buttonId + " .line-chart-icon").addClass('fa-bars-progress');
                }
                else {
                    $(option.buttonId + " .line-chart-icon").removeClass('fa-bars-progress');
                    $(option.buttonId + " .line-chart-icon").addClass('fa-chart-line');                 
                }
            })
        });

        this.exIntGauge = this.initializeGauge("sxcluster-exint-gauge", 0, 300, "Participants");
        this.cogDysGauge = this.initializeGauge("sxcluster-cogdys-gauge", 0, 300, "Participants");
        this.autoGauge = this.initializeGauge("sxcluster-auto-gauge", 0, 300, "Participants");

        var sleep1target = 0, sleep2target = 0;
        var auto1target = 0, auto2target = 0;
        var energize1target = 0, energize2target = 0;

        this.parent.selectedForecastRandomized.forEach(x => {
            if (x.AppendixId == 5) {
                sleep1target += x.Count;
            }
            else if (x.AppendixId == 6) {
                sleep2target += x.Count;
            }
            else if (x.AppendixId == 8) {
                auto1target += x.Count;
            }
            else if (x.AppendixId == 9) {
                auto2target += x.Count;
            }
            else if (x.AppendixId == 11) {
                energize1target += x.Count;
            }
            else if (x.AppendixId == 12) {
                energize2target += x.Count;
            }
        });

        var totalTargets = {
            "sxcluster-total-target-sleep": sleep1target + sleep2target,
            "sxcluster-total-target-auto": auto1target + auto2target,
            "sxcluster-total-target-energize": energize1target + energize2target
        };

        Object.keys(totalTargets).forEach(id => {
            if (document.getElementById(id)) {
                document.getElementById(id).innerText = totalTargets[id];
            }
        })

        this.sleep1Gauge = this.initializeGauge("sxcluster-sleep1-gauge", 0, sleep1target, "Participants");  //s
        this.sleep2Gauge = this.initializeGauge("sxcluster-sleep2-gauge", 0, sleep2target, "Participants");  //s

        this.auto1Gauge = this.initializeGauge("sxcluster-auto1-gauge", 0, auto1target, "Participants");  //s
        this.auto2Gauge = this.initializeGauge("sxcluster-auto2-gauge", 0, auto2target, "Participants");  //s

        this.energize1Gauge = this.initializeGauge("sxcluster-energize1-gauge", 0, energize1target, "Participants");    //s
        this.energize2Gauge = this.initializeGauge("sxcluster-energize2-gauge", 0, energize2target, "Participants");    //s

        this.sleep1Target = sleep1target;
        this.sleep2Target = sleep2target;
        this.auto1target = auto1target;
        this.auto2target = auto2target;
        this.energize1target = energize1target;
        this.energize2target = energize2target;

        this.exIntChart = this.initializeChart("sxcluster-exint-chart");
        this.cogDysChart = this.initializeChart("sxcluster-cogdys-chart");
        this.autoChart = this.initializeChart("sxcluster-auto-chart");

        this.sleep1Chart = this.initializeChart("sxcluster-sleep1-chart", sleep1target);  //s
        this.sleep2Chart = this.initializeChart("sxcluster-sleep2-chart", sleep2target);   //s

        this.auto1Chart = this.initializeChart("sxcluster-auto1-chart", auto1target);  //s
        this.auto2Chart = this.initializeChart("sxcluster-auto2-chart", auto2target);   //s

        this.energize1Chart = this.initializeChart("sxcluster-energize1-chart", energize1target);
        this.energize2Chart = this.initializeChart("sxcluster-energize2-chart", energize2target);
    }

    UpdateData(aggregatedParticipants: AggregatedParticipants): void {
        //this.updateSymptomClusterGauges(aggregatedParticipants.ClusterExInt[1], aggregatedParticipants.ClusterCogn[1], aggregatedParticipants.ClusterAuto[1]);
        this.exIntGauge.series[0].points[0].update(aggregatedParticipants.ClusterExInt[1]);
        this.cogDysGauge.series[0].points[0].update(aggregatedParticipants.ClusterCogn[1]);
        this.autoGauge.series[0].points[0].update(aggregatedParticipants.ClusterAuto[1]);
        //console.log(this.exIntGauge);

        this.sleep1Gauge.series[0].points[0].update(aggregatedParticipants.ClusterSleep1);//s
        this.sleep2Gauge.series[0].points[0].update(aggregatedParticipants.ClusterSleep2);//s

        this.auto1Gauge.series[0].points[0].update(aggregatedParticipants.ClusterAuto1);//s
        this.auto2Gauge.series[0].points[0].update(aggregatedParticipants.ClusterAuto2);//s

        this.energize1Gauge.series[0].points[0].update(aggregatedParticipants.ClusterEnergize1);//s
        this.energize2Gauge.series[0].points[0].update(aggregatedParticipants.ClusterEnergize2);//s

        this.exIntChart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.VitSymExInt == 1)));
        this.exIntChart.redraw();

        this.cogDysChart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.VitSymCogDys == 1)));
        this.cogDysChart.redraw();

        this.autoChart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.VitSymAutoDys == 1)));
        this.autoChart.redraw();

        this.sleep1Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 5)));   //s
        this.sleep1Chart.redraw();
        this.sleep2Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 6)));   //s
        this.sleep2Chart.redraw();

        this.auto1Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 8)));   //s
        this.auto1Chart.redraw();
        this.auto2Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 9)));   //s
        this.auto2Chart.redraw();

        this.energize1Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 11)));   //s
        this.energize1Chart.redraw();
        this.energize2Chart.series[0].setData(this.createChartData(this.parent.selectedParticipants.filter((p: Participant) => p.AppendixId == 12)));   //s
        this.energize2Chart.redraw();
    }

    private initializeGauge(id: string, current: number, target: number, totalLabel: string): any {

        let gauge: any = Highcharts.chart(id, {
            chart: {
                type: 'solidgauge'
            },
            title: null,
            credits: { enabled: false },
            pane: {
                center: ['50%', '90%'],
                size: '170%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: '#ffc757',
                    innerRadius: '70%',
                    outerRadius: '100%',
                    shape: 'arc'
                }
            },
            exporting: {
                enabled: false
            },
            tooltip: {
                enabled: false
            },
            yAxis: {
                lineWidth: 0,
                tickWidth: 0,
                minorTickInterval: null,
                tickAmount: 2,
                tickPositions: [0, target],
                labels: {
                    y: 20,
                    distance: -18,
                    style: {
                        fontSize: '14px'
                    }
                },
                min: 0,
                max: target,
                title: {
                    text: null,
                    //y: -70
                }
            },
            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: 50,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            },
            series: [{
                name: 'Participants',
                data: [{
                    y: current,
                    innerRadius: '70%'
                }],
                dataLabels: {
                    formatter: function () {
                        let label: string = '<div style="text-align:center">';
                        label += '<span style="font-size:20px">' + Highcharts.numberFormat(this.y, 0, '', ',') + '</span><br/>';
                        label += '<span style="font-size:12px;opacity:0.4">Participants</span><br/>';
                        label += '<span style="font-size:16px">(' + Highcharts.numberFormat((this.y / target) * 100, 0, '', ',') + '%)</span>';
                        label += '</div>';
                        return label;
                    }

                    //format:
                    //    '<div style="text-align:center">' +
                    //    '<span style="font-size:25px">{point.y:,.0f}</span><br/>' +
                    //    '<span style="font-size:12px;opacity:0.4">' + totalLabel + '</span>' +
                    //    '</div>',
                },
                tooltip: {
                    valueSuffix: ' Total ' + totalLabel
                }
            }]
        });
        return gauge;
    }

    private initializeChart(id: string, target?: number): any {

        let chart = Highcharts.chart(id, {
            chart: {
                backgroundColor: 'white',
            },
            credits: { enabled: false },
            title: { text: null },
            xAxis: {
                type: 'datetime',
                //max: maxDate,
                showLastLabel: true,
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%e %b %Y', this.value);
                    }
                }
            },
            yAxis: {
                //max: maxEnrollment,
                title: {
                    text: 'Participants'
                },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',');
                    }
                },
                plotLines: [{
                    value: target || 300,
                    dashStyle: 'longdash',
                    label: {
                        text: 'Target',
                        y: -5
                    },
                    zIndex: 5
                }],
                max: (target || 300) + 50
            },
            plotOptions: {
                line: {
                    stickyTracking: false,
                    findNearestPointBy: 'xy',
                    marker: {
                        enabled: false
                    }
                },
            },
            tooltip: {
                xDateFormat: '%e %b %Y',
                shared: false
            },
            legend: {
                enabled: false,
                //symbolWidth: 0
            },
            series: [{ name: "Actual", color: "#152850", data:[] }] //RECOVER dark blue
        });

        return chart;
    }

    private createChartData(participants: Participant[]): ChartDataPoint[] {

        let data: ChartDataPoint[] = [];

        if (participants.length == 0) return data;

        let dayMonthDictionary: Map<number, number[]> = new Map<number, number[]>(); //value: array of counts by study (to facilitate rate computations)

        participants.forEach((p: Participant) => {
            let studyCounts: number[] = [];
            let dateOfInterest: number = p.DateRandomized.getTime();

            if (dateOfInterest > 0) {
                if (dayMonthDictionary.has(dateOfInterest)) {
                    studyCounts = dayMonthDictionary.get(dateOfInterest);
                }
                if (studyCounts[p.StudyId] == undefined) studyCounts[p.StudyId] = 0;
                studyCounts[p.StudyId] += 1;
                dayMonthDictionary.set(dateOfInterest, studyCounts);
            }
        });

        //add up cummulative enrollment over time
        let lastDate: number = -1;
        let countToDate: number = 0;
        dayMonthDictionary.forEach((studyCounts: number[], date: number) => {
            countToDate += SumArrayElements(studyCounts);

            if (date != lastDate) {
                data.push(new ChartDataPoint(date, countToDate));
                lastDate = date;
            }
        });

        return data;
    }

}